import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { HStack, IconButton, Link } from "@chakra-ui/react";
import { FiEdit } from "react-icons/fi";

import { Organization } from "types/organization";

interface Props {
  organization: Organization;
}

const OrganizationActions: React.FC<Props> = ({ organization }: Props) => (
  <HStack spacing="2" justifyContent="flex-end">
    <Link as={RouterLink} to={`/organization/${organization.id}`}>
      <IconButton
        aria-label="Update Organization"
        icon={<FiEdit />}
        isRound
        size="lg"
      />
    </Link>
  </HStack>
);

export default OrganizationActions;
